import React from 'react';
import { X, Download } from 'lucide-react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  url: string;
}

function isPDF(url: string): boolean {
  return url.toLowerCase().endsWith('.pdf') || url.includes('application/pdf');
}

export const InvoiceViewerModal: React.FC<Props> = ({ isOpen, onClose, url }) => {
  if (!isOpen || !url) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="w-full max-w-3xl mx-4 bg-white rounded-xl shadow-2xl flex flex-col max-h-[90vh]">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200">
          <p className="text-sm font-semibold text-slate-700">Invoice Preview</p>
          <div className="flex items-center gap-2">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              download
              className="flex items-center gap-1 text-[11px] font-medium text-blue-600 hover:text-blue-800"
            >
              <Download size={13} /> Download
            </a>
            <button
              type="button"
              onClick={onClose}
              className="p-1 rounded hover:bg-slate-100 text-slate-500 transition-colors"
            >
              <X size={18} />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-auto p-4 flex items-center justify-center bg-slate-50">
          {isPDF(url) ? (
            <iframe
              src={url}
              title="Invoice PDF"
              className="w-full h-[70vh] rounded border border-slate-200"
            />
          ) : (
            <img
              src={url}
              alt="Invoice"
              className="max-w-full max-h-[70vh] object-contain rounded shadow"
            />
          )}
        </div>
      </div>
    </div>
  );
};
